import { createFileRoute } from '@tanstack/react-router'

import { UnsExplorer } from '@/components/UnsExplorer'

export const Route = createFileRoute('/_app/connected/explorer')({
  component: ConnectedExplorerPage,
})

function ConnectedExplorerPage() {
  return (
    <UnsExplorer
      wsAddress={import.meta.env.VITE_SHARED_WS_ADDRESS}
      username={import.meta.env.VITE_WS_USERNAME}
      password={import.meta.env.VITE_WS_PASSWORD}
      rootName="HTCCorp"
      topicFilters="HTCCorp/#"
      clientIdPrefix="stories_uns_connected"
    />
  )
}
